import React from 'react';

import {
  FormControl, InputLabel, MenuItem, Select, SelectChangeEvent,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/en-au';

import { ADAPTER_DAY_JS_LOCALE } from '../../utils/common/constants';

const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

interface DayTimePickerProps {
  value: { day: number, time: Dayjs };
  onChange: (newValue: { day: number, time: Dayjs }) => void;
}

const DayTimePicker = ({ value, onChange, ...rest }: DayTimePickerProps) => {
  const handleDayChange = (event: SelectChangeEvent<string>) => {
    const dayIndex = daysOfWeek.indexOf(event.target.value as string);
    onChange({ ...value, day: dayIndex });
  };

  const handleTimeChange = (newValue: Dayjs | null) => {
    if (newValue) {
      onChange({ ...value, time: newValue });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ADAPTER_DAY_JS_LOCALE}>
      <FormControl fullWidth margin="normal">
        <InputLabel id="day-of-week-label">Day of Week</InputLabel>
        <Select
          labelId="day-of-week-label"
          id="day-of-week-select"
          value={daysOfWeek[value.day]}
          label="Day of Week"
          onChange={handleDayChange}
          {...rest}
        >
          {daysOfWeek.map((day) => (
            <MenuItem key={day} value={day}>
              {day}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TimePicker
        label="Time"
        value={value.time}
        onChange={handleTimeChange}
        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
      />
    </LocalizationProvider>
  );
};

export default DayTimePicker;
